import type { CGMSessionEndedActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { usePolyglot } from "src/contexts"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: CGMSessionEndedActivity;
}

export const CGMSessionEndedActivityTitle = forwardRef<HTMLDivElement, Props>(
  function CGMSessionEndedActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      activity,
      ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t(
          "components.activity_name.cgm_session_ended",
        )}
      </div>
    )
  },
)
